import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import { BUSINESS_FIELDS } from '@modules/form-wizard/utils'

export default class LpgApplianceDealerLicence extends React.Component {
  resource = '/liquid_petroleum_gas'
  form_key = 'liquid_petroleum_gas'
  defaults = {
    license_type: 'appliance dealer',
  }

  read_params = {
    admin: true,
    label: ' ',
    default: 'Default',
    values: {
      'Default': {
        license_type: 'appliance dealer',
      },
    },
  }
  
  // Delete lines as needed
  fee = 30.0
  // free = true
  // postpaid = true
  skip_location = true
  hide_buttons = false
  custom_actions = []
  business_only = true

  validate = null

  foremost = null

  /*
  t.boolean :renewal, default: false
      t.string :license_type # dealer, sub-dealer, installer, container re-builder, or appliance dealer

      # Dealer Sub-Dealer or Installer
      t.string :certified_technicians_list, array: true, default: []
      t.string :storage_capacity
      t.attachment :insurance_letter_upload
      t.string :manager_f_name
      t.string :manager_l_name

      # Rebuilder of Containers
      t.string :rebuilding_equipment_list, array: true, default: []
      t.string :welding_equipment_details
      t.string :test_jacket_details
      t.string :certified_welders_list, array: true, default: []

      # Appliance Dealer
      t.string :appliance_manufacturer
      t.string :appliance_type
      t.string :appliance_model
      t.attachment :appliance_verification_upload
  */

  fields = form => [
    ...BUSINESS_FIELDS(form),
    {
      name: 'license_type',
      save: true,
      hide: true,
      // label: 'What type of license are you applying for?',
      // options: [
      //   'dealer',
      //   'sub-dealer',
      //   'installer',
      //   'container re-builder',
      //   'appliance dealer',
      // ],
    },
    {
      name: 'renewal',
      label: 'Are you applying for the renewal of a license?',
      type: 'select:bool',
    },
    // {
    //   name: 'storage_capacity',
    //   label: 'Storage capacity of appliances',
    // },
    // {
    //   name: 'insurance_letter_upload',
    //   label: 'Insurance letter',
    //   key: 'image.0',
    //   type: 'file:all',
    // },
    '::Person who will manage operations',
    {
      name: 'manager_f_name',
      label: 'First Name',
    },
    {
      name: 'manager_l_name',
      label: 'Last Name',
    },

    // '::Rebuilder of Containers',
    // {
    //   name: 'welding_equipment_details',
    //   type: 'textarea',
    // },
    // {
    //   name: 'test_jacket_details',
    //   type: 'textarea',
    // },
    // {
    //   name: 'certified_welders_list',
    //   label:
    //     'Name and welding certificates of persons who will be carrying out the welding',
    //   columns: ['first_name', 'last_name', 'certificate'],
    // },
    '::Appliance Dealer',
    {
      name: 'appliance_manufacturer',
    },
    {
      name: 'appliance_type',
    },
    {
      name: 'appliance_model',
    },
    {
      name: 'appliance_verification_upload',
      label:
        'Verification that the appliances have been manufactured in accordance with either the American or Canadian Gas Association standards',
      key: 'image.1',
      type: 'file:all',
      required: false,
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
